import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  recdocsDetail: {},
  recdocsCount: null,
  recdocsList: [],
  eventsList: [],
  purchases_from_siiList: [],
  purchases_from_siiCount: null,
  purchases_from_siiDetail: {},
  woemailList: [],
  woemailCount: null
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
